import { FIRST_PARTY_CCP_PRODUCT_IDS } from "@atlassian/surface-analytics";
import { envType } from "@atlassiansox/analytics-web-client";

const getEnvironment = (): string => {
    switch (process.env["CLIENT_LIBRARY_ENV"]) {
        case "production":
            return envType.PROD;
        case "staging":
            return envType.STAGING;
        case "development":
            return envType.DEV;
        default:
            return envType.LOCAL;
    }
};

const env = getEnvironment() === envType.PROD ? "prod" : "staging";
export const JSM_PRODUCT_ID =
    FIRST_PARTY_CCP_PRODUCT_IDS[env].jira_service_management_cloud;
export const JPD_PRODUCT_ID =
    FIRST_PARTY_CCP_PRODUCT_IDS[env].jira_product_discovery;
